import { useState } from "react";
import { Box, SystemProps, Text } from "@storyofams/react-ui";
import useMediaQuery from "~hooks/useMediaQuery";
import { RichText } from "../../RichText";
import { NhAccordion } from "../NhComponents/NhAccordion";

interface QuestionListProps extends SystemProps {
  content: {
    title?: string;
    question_list?: { question: string; answer: any; _uid: string }[];
  };
}

export const QuestionList = ({ content, ...props }: QuestionListProps) => {
  const [isOpen, setIsOpen] = useState(0);
  const scrollToTop = (i) => {
    const el = document?.getElementById(`${"nql" + i}`);

    if (el) {
      setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
    }
  };
  const matchesMobile: boolean = useMediaQuery("(max-width: 769px)");
  return (
    <Box width={"100%"}>
      <Box display={"flex"} justifyContent={"center"}>
        <Text
          fontFamily={"DINPro"}
          fontWeight={700}
          fontSize={["36px", "52px"]}
          mb={["20px", 4]}
        >
          {content.title}
        </Text>
      </Box>
      <Box display={"flex"} justifyContent={"center"}>
        <Box
          borderTopColor="grey200"
          maxWidth={["none", "880px"]}
          width="100%"
          {...props}
        >
          {content?.question_list?.[0]?.question &&
            content?.question_list?.map((question, i) => (
              <Box
                id={"nql" + i}
                css={{
                  "scroll-margin-top": matchesMobile ? "50px" : "130px",
                }}
                onClick={() => {
                  if (i === isOpen) {
                    setIsOpen(null);
                  } else {
                    setIsOpen(i);
                    scrollToTop(i);
                  }
                }}
              >
                <NhAccordion
                  isFAQ
                  isOpen={!i}
                  title={question?.question}
                  key={question?._uid}
                  close={i !== isOpen}
                >
                  <RichText
                    fontSize={2}
                    lineHeight={"22.4px"}
                    text={question?.answer}
                  />
                </NhAccordion>
              </Box>
            ))}
        </Box>
      </Box>
    </Box>
  );
};
